import { ReactNode } from 'react';

import CountryFlagUKIcon from '@qlub-dev/qlub-kit/dist/assets/icons/CountryFlagEN';
import CountryFlagJapanIcon from '@qlub-dev/qlub-kit/dist/assets/icons/CountryFlagJP';
import CountryFlagTR from '@qlub-dev/qlub-kit/dist/assets/icons/CountryFlagTR';
import CountryFlagES from '@qlub-dev/qlub-kit/dist/assets/icons/CountryFlagES';
import CountryFlagChina from '@qlub-dev/qlub-kit/dist/assets/icons/CountryFlagZH';
import CountryFlagSaudi from '@qlub-dev/qlub-kit/dist/assets/icons/CountryFlagAR';
import CountryFlagUAEIcon from '@qlub-dev/qlub-kit/dist/assets/icons/CountryFlagUAEIcon';
import CountryFlagKO from '@qlub-dev/qlub-kit/dist/assets/icons/CountryFlagKO';
import CountryFlagBr from '@qlub-dev/qlub-kit/dist/assets/icons/CountryFlagBr';
import CountryFlagRU from '@qlub-dev/qlub-kit/dist/assets/icons/CountryFlagRU';

export interface ITranslationType {
    key: string;
    icon: ReactNode;
    text: Record<string, string>;
}

const getLanguageData = (cc?: string): ITranslationType[] => {
    return [
        {
            key: 'en',
            text: { confirm: 'Confirm', cancel: 'Cancel', changeLanguage: 'Change language' },
            icon: <CountryFlagUKIcon />,
        },
        {
            key: 'en-sg',
            text: { confirm: 'Confirm', cancel: 'Cancel', changeLanguage: 'Change language' },
            icon: <CountryFlagUKIcon />,
        },
        {
            key: 'ja',
            text: { confirm: '確認する', cancel: 'キャンセル', changeLanguage: 'Change language' },
            icon: <CountryFlagJapanIcon />,
        },
        {
            key: 'pt',
            text: { confirm: 'Confirmar', cancel: 'Cancelar', changeLanguage: 'Alterar idioma' },
            icon: <CountryFlagBr />,
        },
        {
            key: 'ar',
            text: { confirm: 'تأكيد', cancel: 'الغاء', changeLanguage: 'تغيير اللغة' },
            icon: cc === 'sa' ? <CountryFlagSaudi /> : <CountryFlagUAEIcon />,
        },
        {
            key: 'tr',
            text: { confirm: 'Onayla', cancel: 'İptal Et', changeLanguage: 'Dil değiştir' },
            icon: <CountryFlagTR />,
        },
        {
            key: 'zh',
            text: { confirm: '确认', cancel: '  取消', changeLanguage: '更改语言' },
            icon: <CountryFlagChina />,
        },
        {
            key: 'hk',
            text: { confirm: '確認', cancel: '  取消', changeLanguage: '更改語言' },
            icon: <CountryFlagChina />,
        },
        {
            key: 'es',
            text: { confirm: 'Confirmar', cancel: 'Cancelar', changeLanguage: 'Cambiar idioma' },
            icon: <CountryFlagES />,
        },
        {
            key: 'ko',
            text: { confirm: '변경', cancel: '취소', changeLanguage: '언어 변경' },
            icon: <CountryFlagKO />,
        },
        {
            key: 'ru',
            text: { confirm: 'Подтвердить', cancel: 'Отмена', changeLanguage: 'Изменить язык' },
            icon: <CountryFlagRU />,
        },
    ];
};

export default getLanguageData;
